import { Button, Table, Tag } from 'antd';
import React, { useState } from 'react';

const FeedbbackDesktop = ({ feedbackReportData }) => {

    const [expandedRows, setExpandedRows] = useState([]);

    const toggleRow = (key) => {
        setExpandedRows(prev =>
            prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]
        );
    };

    const isExpanded = (key) => expandedRows.includes(key);

    const renderTextWithToggle = (text, key, limit = 150) => {
        if (!text || text.length <= limit) return text;
        const expanded = isExpanded(key);
        return (
            <>
                <div style={{ wordBreak: 'break-word' }}>
                    {expanded ? text : `${text.slice(0, limit)}...`}
                </div>
                <div
                    onClick={() => toggleRow(key)}
                    style={{ padding: 0, cursor: 'pointer' }}
                >
                    {expanded ? 'Read Less' : 'Read More'}
                </div>
            </>
        );
    };

    const renderListWithToggle = (points, key, limit = 2) => {
        if (!Array.isArray(points) || points.length === 0) return <li>None</li>;

        const expanded = isExpanded(key);
        const visiblePoints = expanded ? points : points.slice(0, limit);

        return (
            <>
                <ul style={{ paddingLeft: 16, margin: 0 }}>
                    {visiblePoints.map((point, index) => (
                        <li key={index}>{point}</li>
                    ))}
                </ul>
                {points.length > limit && (
                    <div
                        onClick={() => toggleRow(key)}
                        style={{ padding: 0, cursor: 'pointer' }}
                    >
                        {expanded ? 'Read Less' : 'Read More'}
                    </div>
                )}
            </>
        );
    };


    const columns = [
        {
            title: "Criteria",
            dataIndex: "criteria",
            // width: "15%",
            align: "center",
        },
        {
            title: "AI Score",
            dataIndex: "ai_evaluation_score",
            // width: "10%",
            align: "center",
            render: (text) => <Tag color="volcano">{text}</Tag>,
        },
        {
            title: "Tutor Score",
            dataIndex: "tutor_expected_score",
            // width: "10%",
            align: "center",
            render: (text) => <Tag color="red">{text}</Tag>,
        },
        {
            title: "Similarity",
            dataIndex: "similarity_in_approach",
            // width: "10%",
            align: "center",
            render: (text) => <Tag color="blue">{text}</Tag>,
        },
        {
            title: "AI Feedback",
            dataIndex: "ai_feedback",
            render: (text, record) => renderTextWithToggle(text, `ai-${record.key}`),
        },
        {
            title: "Tutor Feedback",
            dataIndex: "tutor_feedback",
            render: (text, record) => renderTextWithToggle(text, `tutor-${record.key}`),
        },
        {
            title: "Unfollowed Tutor Points",
            dataIndex: "unfollowed_tutor_points",
            render: (points, record) => renderListWithToggle(points, `points-${record.key}`),
        },

    ];

    const data = feedbackReportData?.feedback_report?.map((issue, index) => ({
        key: index,
        ...issue,
    })) || [];

    return (
        <div
            style={{
                maxHeight: "400px",
                overflowY: "auto",
                padding: "10px",
            }}
        >
            <Table
                columns={columns}
                dataSource={data}
                pagination={false}
                bordered
                rowClassName="table-row"
            />
            {feedbackReportData?.feedback_remarks && <p><strong>Remarks:</strong> {feedbackReportData?.feedback_remarks}</p>}
        </div>
    );
};

export default FeedbbackDesktop;
